// ── DATA CONFIG — Edit here to add / remove / update items
// URL de la API de contacto (backend propio). Mantener secretos solo en el backend.
// Si se deja vacio, usa por defecto /api/v1/contact
window.__CONTACT_API_URL = '';
const runtimeConfig = window.__NUBELASTIC_CONFIG || {};
window.__SERVICES = [
    {
        icon: `<svg viewBox="0 0 24 24" fill="none" stroke="#0078D4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>`,
        name: "Migraci\xf3n a Azure",
        desc: "Evaluamos tu infraestructura actual y dise\xf1amos un plan de migraci\xf3n seguro, minimizando el tiempo de inactividad y optimizando costos en la nube.",
        tags: [
            "Azure Migrate",
            "Assessment",
            "Landing Zone"
        ]
    },
    {
        icon: `<svg viewBox="0 0 24 24" fill="none" stroke="#0078D4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>`,
        name: "CI/CD con Azure DevOps",
        desc: "Implementamos pipelines de integraci\xf3n y entrega continua robustos: desde control de versiones hasta deploys automatizados con aprobaciones y rollback.",
        tags: [
            "Azure Pipelines",
            "Repos",
            "Artifacts"
        ]
    },
    {
        icon: `<svg viewBox="0 0 24 24" fill="none" stroke="#0078D4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>`,
        name: "Monitoreo con KQL",
        desc: "Configuramos dashboards, alertas y queries en Azure Monitor y Log Analytics usando KQL, para observabilidad completa de tus workloads en producci\xf3n.",
        tags: [
            "Log Analytics",
            "KQL",
            "Azure Monitor"
        ]
    },
    {
        icon: `<svg viewBox="0 0 24 24" fill="none" stroke="#0078D4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>`,
        name: "IaC con Bicep y Terraform",
        desc: "Definimos y versionamos tu infraestructura como c\xf3digo. Bicep para entornos Azure-nativos; Terraform para estrategias multi-cloud o h\xedbridas.",
        tags: [
            "Bicep",
            "Terraform",
            "ARM Templates"
        ]
    }
];
window.__CERTS = [
    {
        code: "AZ-900",
        name: "Azure Fundamentals",
        desc: "Fundamentos de servicios cloud y Azure",
        status: "active"
    },
    {
        code: "AZ-204",
        name: "Azure Developer Associate",
        desc: "Desarrollo de soluciones en Azure",
        status: "active"
    },
    {
        code: "AZ-400",
        name: "DevOps Engineer Expert",
        desc: "Dise\xf1o e implementaci\xf3n de pr\xe1cticas DevOps en Azure",
        status: "active"
    },
    {
        code: "SC-?",
        name: "Ciberseguridad",
        desc: "Certificaciones de seguridad en Azure \u2014 pr\xf3ximamente",
        status: "pending"
    }
];
// Contact form — service options (dropdown)
window.__SERVICE_OPTIONS = [
    "Migraci\xf3n a Azure",
    "CI/CD con Azure DevOps",
    "Monitoreo con KQL",
    "IaC con Bicep / Terraform",
    "Otro / Consultor\xeda general"
];
// ── Year
document.getElementById('year').textContent = new Date().getFullYear();
// ── Render Services
const servicesGrid = document.getElementById('services-grid');
window.__SERVICES.forEach((s, i)=>{
    const card = document.createElement('div');
    card.className = 'service-card reveal';
    card.style.transitionDelay = `${i * 80}ms`;
    card.innerHTML = `
    <div class="service-icon">${s.icon}</div>
    <div class="service-name">${s.name}</div>
    <div class="service-desc">${s.desc}</div>
    <div class="service-tags">${s.tags.map((t)=>`<span class="service-tag">${t}</span>`).join('')}</div>
  `;
    servicesGrid.appendChild(card);
});
// ── Render Certs
const certsGrid = document.getElementById('certs-grid');
window.__CERTS.forEach((c, i)=>{
    const card = document.createElement('div');
    card.className = `cert-card reveal${c.status === 'pending' ? ' pending' : ''}`;
    card.style.transitionDelay = `${i * 80}ms`;
    card.innerHTML = `
    <div class="cert-badge ${c.status === 'active' ? 'active' : 'pending-badge'}">${c.code}</div>
    <div class="cert-name">${c.name}</div>
    <div class="cert-desc">${c.desc}</div>
    <span class="cert-status ${c.status}">${c.status === 'active' ? 'Certificado' : 'En progreso'}</span>
  `;
    certsGrid.appendChild(card);
});
// ── Render Contact Select
const sel = document.getElementById('f-service');
const defOpt = document.createElement('option');
defOpt.value = '';
defOpt.textContent = "Selecciona un servicio\u2026";
sel.appendChild(defOpt);
window.__SERVICE_OPTIONS.forEach((opt)=>{
    const o = document.createElement('option');
    o.value = opt;
    o.textContent = opt;
    sel.appendChild(o);
});
// ── Scroll: nav shadow + reveal
const nav = document.getElementById('main-nav');
const observer = new IntersectionObserver((entries)=>{
    entries.forEach((e)=>{
        if (e.isIntersecting) e.target.classList.add('visible');
    });
}, {
    threshold: 0.12
});
function initReveal() {
    document.querySelectorAll('.reveal').forEach((el)=>observer.observe(el));
}
initReveal();
window.addEventListener('scroll', ()=>{
    nav.classList.toggle('scrolled', window.scrollY > 20);
});
// ── Form submit (configured for Azure Static Web Apps API with mailto fallback)
const contactForm = document.getElementById('contact-form');
if (contactForm) contactForm.addEventListener('submit', (event)=>{
    event.preventDefault();
    handleSubmit();
});
async function handleSubmit() {
    const name = document.getElementById('f-name').value.trim();
    const email = document.getElementById('f-email').value.trim();
    const service = document.getElementById('f-service').value;
    const msg = document.getElementById('f-msg').value.trim();
    const honeypot = (document.getElementById('f-company-website')?.value || '').trim();
    const feedback = document.getElementById('form-feedback');
    if (feedback) {
        feedback.textContent = '';
        feedback.classList.remove('error', 'success');
    }
    if (!name || !email || !service || !msg) {
        if (feedback) {
            feedback.textContent = 'Por favor completa todos los campos obligatorios.';
            feedback.classList.add('error');
        }
        return;
    }
    const submitBtn = document.querySelector('.form-submit');
    const originalBtnText = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.innerHTML = 'Enviando...';
    // Usa la API configurada (ej. Logic App) o la API integrada de Azure Static Web Apps
    const apiEndpoint = runtimeConfig.contactApiUrl || window.__CONTACT_API_URL || '/api/v1/contact';
    try {
        const response = await fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name,
                email,
                service,
                message: msg,
                honeypot
            })
        });
        if (response.ok) {
            if (feedback) {
                feedback.textContent = 'Mensaje enviado con exito. Te responderemos pronto.';
                feedback.classList.add('success');
            }
            contactForm?.reset();
        } else {
            let message = 'No se pudo enviar el mensaje. Intenta de nuevo en unos minutos.';
            try {
                const data = await response.json();
                if (data?.message) message = data.message;
            } catch (_error) {
            // keep default message
            }
            if (feedback) {
                feedback.textContent = message;
                feedback.classList.add('error');
            }
            if (response.status >= 500) throw new Error(`Server error status: ${response.status}`);
        }
    } catch (error) {
        console.warn("Fallo el env\xedo por la API de Azure (probablemente ejecutando localmente sin el emulador SWA). Abriendo gestor de correo alternativo...");
        if (feedback) {
            feedback.textContent = 'No pudimos entregar por API. Abriremos tu cliente de correo como alternativa.';
            feedback.classList.add('error');
        }
        // Fallback a mailto si la API no responde (por ejemplo, desarrollo local)
        const mailto = `mailto:contacto@nubelastic.com` + `?subject=Solicitud: ${encodeURIComponent(service)}` + `&body=${encodeURIComponent(`Nombre: ${name}\nEmail: ${email}\n\n${msg}`)}`;
        window.location.href = mailto;
    } finally{
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalBtnText;
    }
}

//# sourceMappingURL=front.171f7005.js.map
